export default class PronunciationBanner {
    constructor() {
        this.banners = document.querySelectorAll('.pronunciation-banner');
        this.init();
    }

    init() {
        this.banners.forEach(banner => {
            const audioContainer = banner.querySelector('.pronunciation-banner-audio');
            if (!audioContainer) return;

            const button = banner.querySelector('[data-audio-control]');
            if (!button) return;

            const audioFiles = audioContainer.dataset.audio.split(',').filter(file => file.trim());
            if (!audioFiles.length) return;

            // Create audio element
            const audio = new Audio();
            let isPlaying = false;

            button.addEventListener('click', () => {
                if (isPlaying) {
                    audio.pause();
                    audio.currentTime = 0;
                    isPlaying = false;
                    button.setAttribute('aria-label', 'Play pronunciation');
                } else {
                    // Pick random audio file
                    const randomIndex = Math.floor(Math.random() * audioFiles.length);
                    const selectedFile = audioFiles[randomIndex];
                    audio.src = selectedFile;

                    audio.play().catch(error => {
                        console.error('Error playing audio:', error);
                    });
                    isPlaying = true;
                    button.setAttribute('aria-label', 'Stop pronunciation');
                }
            });

            // Handle audio end
            audio.addEventListener('ended', () => {
                isPlaying = false;
                button.setAttribute('aria-label', 'Play pronunciation');
            });
        });
    }
} 